/**
 * Hinweis auf eine neue Fassung.
 *
 * Steht im Rahmen des Prüfbüros, also nur für Angemeldete. Auf der
 * Anmeldeseite hätte er niemanden, den er betrifft – wer sich anmeldet,
 * kommt unmittelbar danach hier vorbei und sieht ihn dort.
 *
 * Wichtig ist dabei, dass die Meldung des Service Workers gemerkt wird
 * (siehe `neueFassungVerfuegbar`): sie kommt lange vor der Anmeldung, und
 * ohne Gedächtnis ginge sie verloren – der Benutzer bliebe auf der alten
 * Fassung sitzen, ohne es zu erfahren.
 */

import { useEffect, useState } from 'react'
import { neueFassungLaden, neueFassungVerfuegbar } from '../pwa/aktualisierung'

export function Neufassung() {
  const [bereit, setzeBereit] = useState(false)
  const [laeuft, setzeLaeuft] = useState(false)

  useEffect(() => neueFassungVerfuegbar(() => setzeBereit(true)), [])

  if (!bereit) return null

  // Bewusst nicht klebend: die Kopfzeile des Prüfbüros klebt bereits bei
  // top-0. Zwei klebende Geschwister an derselben Kante überdecken sich – das
  // Banner hätte beim Scrollen Logo, Verwaltung und Abmelden verdeckt. Es
  // steht einmal oben und rollt mit weg.
  return (
    <div
      role="status"
      className="relative z-30 border-b-2 border-akzent-500 bg-akzent-grund px-4 py-2"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-3">
        <span className="text-slate-900">
          Eine neue Fassung steht bereit.{' '}
          {/* Der Zusatz ist kein Beiwerk: beim Laden wird die Seite neu
              aufgebaut, und was in einem offenen Dialog steht und noch nicht
              gespeichert ist, geht dabei verloren. */}
          <span className="text-slate-700">Offene Eingaben vorher speichern.</span>
        </span>
        {/* Lädt nicht von allein: mitten in einer Prüfung soll sich die App
            nicht unter den Händen wegladen. */}
        {/* Beschriftung und Sperre sind hier nicht Zierde: das Umschalten
            dauert einen Moment, und ohne Rückmeldung tippt man ein zweites
            Mal. Weitere Klicks wären wirkungslos – die Sperre im Modul lässt
            nur den ersten durch. */}
        <button
          type="button"
          disabled={laeuft}
          onClick={() => {
            setzeLaeuft(true)
            void neueFassungLaden()
          }}
          className="knopf-haupt ml-auto px-3 py-1"
          style={{ minHeight: '40px' }}
        >
          {laeuft ? 'Lädt …' : 'Jetzt laden'}
        </button>
      </div>
    </div>
  )
}
